import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useCallback, useMemo, useState } from 'sb-hooks'
import { array } from 'common/helpers'

import Star from 'components/ui/Star/Star'

import s from './Stars.scss'


const Stars = (props) => {
  const {
    className, starClassName, starIconClassName,
    style, count, withNumbers,
    active, isBlack, isRed,
    onClick, dataTestId,
  } = props

  const [ hoveredIndex, setHoveredIndex ] = useState(null)

  const isClickable = typeof onClick === 'function'

  const updateHoverIndex = useCallback((index) => {
    if (isClickable) {
      setHoveredIndex(index)
    }
  }, [ isClickable ])

  const createHandleClick = useCallback((num) => {
    // return undefined for correct adaProps inside Star component
    if (!isClickable) {
      return
    }

    return () => onClick(num)
  }, [ isClickable, onClick ])

  const adaProps = useMemo(() => isClickable ? { role: 'button', tabIndex: 0 } : {}, [ isClickable ])
  const buttonTestId = isClickable ? `${dataTestId}Button` : null

  const rootClassName = cx(s.stars, className, {
    [s.clickable]: isClickable,
  })

  return (
    <div className={rootClassName} style={style} data-testid={dataTestId}>
      {
        array.range(1, count).map((num, index) => {
          const hovered = hoveredIndex !== null && index <= hoveredIndex

          if (withNumbers) {
            return (
              <div
                key={index}
                className={s.star}
                onMouseEnter={() => updateHoverIndex(index)}
                onMouseLeave={() => updateHoverIndex(null)}
                onClick={createHandleClick(num)}
                {...adaProps}
                data-testid={buttonTestId}
              >
                <Star
                  className={starClassName}
                  iconClassName={starIconClassName}
                  active={active}
                  hovered={hovered}
                  isBlack={isBlack}
                  isRed={isRed}
                />
                <div className={s.number}>{num}</div>
              </div>
            )
          }

          return (
            <Star
              key={index}
              className={cx(s.star, starClassName)}
              iconClassName={starIconClassName}
              active={active}
              hovered={hovered}
              isBlack={isBlack}
              isRed={isRed}
              onMouseEnter={() => updateHoverIndex(index)}
              onMouseLeave={() => updateHoverIndex(null)}
              onClick={createHandleClick(num)}
              dataTestId={buttonTestId}
            />
          )
        })
      }
    </div>
  )
}

Stars.propTypes = {
  className: PropTypes.string,
  starClassName: PropTypes.string,
  starIconClassName: PropTypes.string,
  style: PropTypes.object,
  active: PropTypes.bool,
  isBlack: PropTypes.bool,
  onClick: PropTypes.func,
  count: PropTypes.number,
  dataTestId: PropTypes.string,
}

Stars.defaultProps = {
  count: 5,
  dataTestId: 'ratingStars',
}


export default Stars
